
import {UserController} from '../controller/UserController';

/*
Static Class User
export: GlobalUser;
*/

class User{

    /*
    CONSTRUCTOR
    */
    constructor(){

        /*
        Properties
        */
        this.api_key = null;
        this.token = null;
        this.user_id = null;
        this.user_name = null;
        this.user_firstname = null;
        this.user_mail = null;
        this.user_role = null;
        this.response = null;
        this.userController = new UserController();

    }

    /**
     * Accessors
     */

    getApiKey(){
        return this.api_key;
    }

    setApiKey(apikey){
        this.api_key = apikey;
    }

    getToken(){
        return this.token;
    }

    setToken(val){
        this.token = val;
    }

    getUserId(){
        return this.user_id;
    }

    setUserId(id){
        this.user_id = id;
    }

    getUserName(){
        return this.user_name;
    }

    setUserName(username){
        this.user_name = username;
    }

    getUserFirstName(){
        return this.user_firstname;
    }

    setUserFirstName(val){
        this.user_firstname = val;
    }

    getUserMail(){
        return this.user_mail;
    }

    setUserMail(val){
        this.user_mail = val;
    }

    getUserRole(){
        return this.user_role;
    }

    setUserRole(val){
        this.user_role = val;
    }

    getResponse(){
        return this.response;
    }

    setResponse(val){
        this.response = val;
    }

    /**
     * FUNCTIONS
     */
    //Called from view/LoginForm.js
    async logIn(username, password){

        let response= await this.userController.logIn(username, password);

        //API call error
        if(response === undefined){
            return undefined;
        }
        //Connection OK
        if (response.response === '200'){
            this.setApiKey(response.dataArray.api_key);
            this.setToken(response.dataArray.token);
            this.setUserName(response.dataArray.user_name);
            this.setUserFirstName(response.dataArray.user_firstname);
            this.setUserId(response.dataArray.user_id);
            this.setUserMail(response.dataArray.user_mail);
            this.setUserRole(response.dataArray.user_role);
            this.setResponse(response);
        }
        //Connection KO
        else{
            this.setApiKey(null);
            this.setToken(null);
            this.setUserName(null);
            this.setUserFirstName(null);
            this.setUserId(null);
            this.setUserMail(null);
            this.setUserRole(null);
            this.setResponse(response)
        }

        return await this;

    }
    

    async changePassword(userid, password){

        let response= await this.userController.changePassword(userid, password);

        //API call error
        if(response === undefined){
            return undefined;
        }

        //Connection OK
        if (response.response === '200'){
            return await response;
        }else{
            return await response;
        }
    }


}

//export default new User();
const GlobalUser = new User(); 
export default GlobalUser;